import {Injectable} from '@angular/core';

@Injectable({providedIn: 'root'})
export class AppNativeDateService {
	addDay(date: Date, numDays: number): Date {
		const result = new Date(date);
		result.setDate(result.getDate() + numDays);
		return result;
	}

	addMonth(date: Date, numMonths: number): Date {
		const result = new Date(date);
		result.setMonth(result.getMonth() + numMonths);
		return result;
	}

	addYear(date: Date, numYears: number): Date {
		const result = new Date(date);
		result.setFullYear(result.getFullYear() + numYears);
		return result;
	}

	clone(date: Date): Date {
		return new Date(date.getTime());
	}

	compareDates(date1: Date, date2: Date): number {
		return date1.getTime() - date2.getTime();
	}

	createDate(year: number, month: number, date: number): Date {
		return new Date(year, month, date);
	}

	format(date: Date, format: string): string {
		return date.toLocaleDateString(undefined, this.parseFormat(format));
	}

	getDate(date: Date): number {
		return date.getDate();
	}

	getDayOfWeek(date: Date): number {
		return date.getDay();
	}

	getDayPeriod(date: Date): string {
		return date.getHours() >= 12 ? 'PM' : 'AM';
	}

	getFirstDayOfWeek(): number {
		return 1;
	}

	getMonth(date: Date): number {
		return date.getMonth();
	}

	getMonthEnd(date: Date): Date {
		return new Date(date.getFullYear(), date.getMonth() + 1, 0);
	}

	getMonthName(date: Date, style?: string): string {
		return date.toLocaleString(undefined, {month: style as Intl.DateTimeFormatOptions['month'] ?? 'long'});
	}

	getMonthStart(date: Date): Date {
		return new Date(date.getFullYear(), date.getMonth(), 1);
	}

	getWeekNumber(date: Date): number {
		const temp = new Date(date.getTime());
		temp.setHours(0, 0, 0, 0);
		temp.setDate(temp.getDate() + 3 - ((temp.getDay() + 6) % 7));
		const week1 = new Date(temp.getFullYear(), 0, 4);
		return 1 + Math.round(((temp.getTime() - week1.getTime()) / 86400000 - 3 + ((week1.getDay() + 6) % 7)) / 7);
	}

	getYear(date: Date): number {
		return date.getFullYear();
	}

	getYearEnd(date: Date): Date {
		return new Date(date.getFullYear(), 11, 31);
	}

	getYearStart(date: Date): Date {
		return new Date(date.getFullYear(), 0, 1);
	}

	isValidDateString(date: string): boolean {
		return !Number.isNaN(Date.parse(date));
	}

	parse(date: string, format: string): Date {
		return new Date(date);
	}

	setHours(date: Date, hour: number): Date {
		const result = new Date(date);
		result.setHours(hour);
		return result;
	}

	setMinutes(date: Date, minute: number): Date {
		const result = new Date(date);
		result.setMinutes(minute);
		return result;
	}

	today(): Date {
		return new Date();
	}

	private parseFormat(format: string): Intl.DateTimeFormatOptions {
		return {year: 'numeric', month: '2-digit', day: '2-digit'};
	}
}
